<template>
  <div
    id="pc-inspiration-gallery"
    :class="[images.length == 0 && isPdp ? 'd-none' : '']"
  >
    <div class="pc-inspiration-page-header" v-if="!isPdp">
      <h2>{{ $resourceString["inspiration.welcome.to.inspiration"] }}</h2>
    </div>
    
    <div class="container-fluid">
      <pc-inspiration-section-page-display-control v-if="!isPdp" />
    </div>

    <pc-inspiration-section-page-gallery v-if="isPdp" />
    <div class="container-fluid" v-else>
      <div class="row mt-4">
        <div class="col-md-12 mb-3">
          <button type="button" class="wf-side-collapse-button wf-side-collapse-button-open btn d-lg-block d-none pl-0" @click="triggerDesktopFilter()">
            <span class="pr-3">{{ !isDesktopFilterShow ? $resourceString['product.Search.Filters.Button.Show'] : $resourceString['product.Search.Filters.Button.Hide'] }}</span> 
            <span class="png-icon png-icon-icons-glyph--k-sort-filter m-0"></span>
          </button>
          <button type="button" class="wf-side-collapse-button wf-side-collapse-button-open btn d-lg-none pl-0" @click="triggerMobileFilter()">
            <span class="pr-3">{{ !isMobileFilterShow ? $resourceString['product.Search.Filters.Button.Show'] : $resourceString['product.Search.Filters.Button.Hide'] }}</span> 
            <span class="png-icon png-icon-icons-glyph--k-sort-filter m-0"></span>
          </button>
        </div>
        <div class="col-12 col-md-3 d-lg-block d-none" v-if="isDesktopFilterShow">
          <div class="row">
            <div class="col-md-12">
              <pc-inspiration-gallery-current-filters/>
            </div>
            <div class="col-md-12">
              <pc-inspiration-gallery-side-filters/>
            </div>
          </div>
        </div>
        <div :class="`col-12 col-md-12 ${isDesktopFilterShow ? 'col-lg-9' : ''}`">
          <pc-inspiration-section-page-gallery />
        </div>
      </div>
    </div>

    <div class="wf-product-category-sidebar-mobile">
      <div :class="`wf-side-collapse ${isMobileFilterShow ? 'wf-side-collapse-active' : ''}`" id="filters-side-collapse">
        <div class="wf-side-collapse-header justify-content-end">
          <button class="wf-side-collapse-button wf-side-collapse-button-close btn" type="button" @click="triggerMobileFilter()">
            {{ $resourceString["product.search.close.button"] }}
            <span class="png-icon png-icon-icons-glyph--g-close" aria-label="close button" />
          </button>
        </div>
        <div class="wf-side-collapse-body">
          <div class="wf-side-collapse-section border-bottom-line">
            <pc-inspiration-gallery-current-filters/>
          </div>
          <div class="wf-side-collapse-section">
            <pc-inspiration-gallery-side-filters/>
          </div>
        </div>
      </div>
    </div>

    <wf-back-to-top-button v-if="pageNumber > 1 && !isPdp" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PcInspirationGallerySideFilters from "./pc-inspiration-gallery-side-filters.vue";
import PcInspirationGalleryCurrentFilters from "./pc-inspiration-gallery-current-filters.vue";
import PcInspirationSectionPageDisplayControl from "./pc-inspiration-section-page-display-control.vue";
import PcInspirationSectionPageGallery from "./pc-inspiration-section-page-gallery.vue";
import WfBackToTopButton from "../wf-back-to-top-button.vue";

export default {
  props: ["isPdp"],
  components: {
    PcInspirationGallerySideFilters,
    PcInspirationGalleryCurrentFilters,
    PcInspirationSectionPageDisplayControl,
    PcInspirationSectionPageGallery,
    WfBackToTopButton
  },
  computed: {
    ...mapGetters({
      pageNumber: "inspirationPage/pageNumber",
      sortOrder: "filters/sortOrder",
      selectedFilters: "filters/selectedFilters",
      pageSize: "inspirationPage/pageSize",
      isFetching: "inspirationPage/isFetching",
      showLoadMore: "inspirationPage/showLoadMore",
      searchTerm: "filters/searchTerm",
      isAscendingOrder: "filters/isAscendingOrder",
      selections: "filters/selections",
      images: "inspirationPage/images"
    }),
    changedData() {
      return `${this.sortOrder}|${this.selectedFilters}|${this.searchTerm}|${this.isAscendingOrder}`;
    }
  },
  data() {
    return {
      isDesktopFilterShow: true,
      isMobileFilterShow: false,
    };
  },
  methods: {
    ...mapActions({
      fetchResults: "inspirationPage/fetchResults",
      setPageNumber: "inspirationPage/setPageNumber",
      setSearchTerm: "filters/setSearchTerm",
      setInitialSelectedFilters: "filters/setInitialSelectedFilters",
      setSortOrder: "filters/setSortOrder",
      setFiltersFromURL: "filters/setFiltersFromURL",
      setFiltersInURL: "filters/setFiltersInURL",
      updateIsPdp: "inspirationPage/updateIsPdp"
    }),
    onSearch() {
      if (!this.isPdp) {
        const ascOrder = this.isAscendingOrder === "asc";
        this.fetchResults({
          filter: {
            ...this.selections,
            OrderColumn: this.sortOrder,
            SortBy: this.sortOrder == "DisplayCollectionName" ? `${this.sortOrder} ${this.isAscendingOrder}` : this.sortOrder,
            PageNumber: this.pageNumber,
            IncludeTotalResultCount: true,
            PageSize: this.pageSize,
            SearchTerm: this.searchTerm,
            IsAscendingOrder: ascOrder
          },
          includefilters: true
        });
      }
    },
    triggerMobileFilter() {
      this.isMobileFilterShow = !this.isMobileFilterShow;
      this.isMobileFilterShow ? document.querySelector("body").style.overflow = 'hidden' : document.querySelector("body").style.overflow = '';
    },
    triggerDesktopFilter() {
      this.isDesktopFilterShow = !this.isDesktopFilterShow;
    }
  },
  created() {
    this.setSortOrder("DisplayCollectionName asc");
    if (location.search) {
      this.setFiltersFromURL();
    } else {
      this.onSearch();
    }
    this.updateIsPdp(this.isPdp ? true : false);

  },
  watch: {
    changedData: {
      handler: function() {
        this.setPageNumber(1);
        this.onSearch();
        !this.isPdp && this.setFiltersInURL("DisplayCollectionName");
      },
      deep: true
    },
    pageNumber: {
      handler: function(newValue, oldValue) {
        if (newValue > 1) this.onSearch();
      },
      deep: true
    }
  }
};
</script>

<style></style>
